import { useMemo } from 'react';
import { MdSecurity, MdViewModule } from 'react-icons/md';
import { RiLockPasswordFill } from 'react-icons/ri';
import { useSelector } from 'react-redux';
import { getActiveUser } from '../components/common/common-functions/common-functions';
import {
  sidebarMenuOptions,
  SidebarMenuOptionsProps,
} from '../constants/SidebarMenuOptions';
import { allAnetarKomisioni } from '../constants/all-anetar-komisioni';
import { useRoleGetter } from '../helpers/getUserInfo';
import { UserStateProps } from '../interfaces/modules.interface';
import { RootState } from '../redux/store';
import { useAuth } from './use-auth';
import { AuthProvider } from '../utilities/enums';

export const useSidebarItems = () => {
  const selectorRole = useSelector((state: UserStateProps) => state.activeUser);
  const userRole = useRoleGetter();

  const { data: loggedInUser, isFetching } = useAuth();

  const { showVerifyFA, showSuggestTfa } = useSelector(
    (state: RootState) => state.verifyFA,
  );

  const role = useMemo(
    () => (selectorRole?.length > 0 ? selectorRole : getActiveUser()),
    [selectorRole],
  );

  const reorderItems = useMemo(() => {
    const sidebarOptions = sidebarMenuOptions(userRole, showVerifyFA);
    if (
      loggedInUser &&
      allAnetarKomisioni.includes(role ?? loggedInUser.rolet[0])
    ) {
      const foundIdx = sidebarOptions.findIndex(el => el.key === '/konkurrime');
      sidebarOptions.push(...sidebarOptions.splice(0, foundIdx));
      return sidebarOptions;
    }
    return sidebarOptions;
  }, [userRole, showVerifyFA, role, loggedInUser]);

  const sidebarItems = () => {
    if (isFetching || !loggedInUser) {
      return [];
    }

    if (showVerifyFA) {
      return [
        {
          key: '/two-fa',
          label: 'Two-Factor Authentication',
          icon: <MdSecurity className="h-5 w-5" />,
        },
      ];
    }

    if (showSuggestTfa) {
      return [
        {
          key: '/two-fa',
          label: 'Two-Factor Authentication',
          icon: <RiLockPasswordFill className="h-5 w-5" />,
        },
      ];
    }

    if (
      loggedInUser.firstLogIn &&
      loggedInUser?.authProvider !== AuthProvider.MICROSOFT
    ) {
      return [
        {
          key: '/ndryshoFjalekalimin',
          label: 'Ndrysho fjalëkalimin',
          icon: <RiLockPasswordFill className="h-5 w-5" />,
        },
      ];
    }

    const loggedInUserRole = loggedInUser.rolet[0];

    if (loggedInUser.rolet.length > 1 && !role) {
      return [
        {
          key: '/modulet',
          label: 'Zgjidh Modulin',
          icon: <MdViewModule className="h-5 w-5" />,
        },
      ];
    }

    const currentRole = role ?? loggedInUserRole;
    const userRoles: SidebarMenuOptionsProps[] = [];

    for (let index = 0; index < reorderItems.length; index++) {
      const element = reorderItems[index];
      if (element.roles.includes(currentRole)) {
        userRoles.push(element);
      }
    }

    return userRoles.filter(item => item.key !== '/ndryshoFjalekalimin');
  };

  return { sidebarItems };
};
